module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-116.a81ec41.woff2";